import { useTranslation } from 'react-i18next';
import React from 'react';
import { Box, Typography } from '@mui/material';

const ErrorPage = (): JSX.Element => {
  const { t } = useTranslation('component');
  return (
    <Box sx={{ textAlign: 'center', m: '24px' }}>
      <Typography variant="h1">{t('Error.Title')}</Typography>
    </Box>
  );
};

export default ErrorPage;
